import { Suspense, useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Modal } from '../../components/modals/Modal';
import { ModalContext } from '../../context/ModalContext';
import type { AnyModalEntry } from './modalRegistry';
import { modalRegistry } from './modalRegistry';

export const ModalHost = () => {
  const { state, closeModal } = useContext(ModalContext);

  // useState (not useRef) so the container is stable and never read during render
  const [container] = useState(() => {
    const div = document.createElement('div');
    div.setAttribute('id', 'modal-portal');
    return div;
  });

  useEffect(() => {
    document.body.appendChild(container);
    return () => {
      document.body.removeChild(container);
    };
  }, [container]);

  if (!state.isOpen || state.type === null) return null;

  // Cast to allow string-keyed lookup; AnyModalEntry gives a safe component shape.
  // noUncheckedIndexedAccess makes this | undefined, so the guard below is required.
  const entry = (modalRegistry as Record<string, AnyModalEntry | undefined>)[state.type];
  if (entry === undefined) {
    console.warn(`[ModalHost] No registry entry for modal type: "${state.type}"`);
    return null;
  }

  const ModalComponent = entry.component;

  return createPortal(
    <Modal {...(entry.title !== undefined ? { title: entry.title } : {})} onClose={closeModal}>
      <Suspense fallback={<div className="modal-body-loading" />}>
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        <ModalComponent {...(state.props as any)} onClose={closeModal} />
      </Suspense>
    </Modal>,
    container
  );
};
